import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useFavorites } from "@/components/FavoriteButton";
import PropertyCard from "@/components/PropertyCard";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

export default function Favorites() {
  const { user } = useAuth();
  const { ids } = useFavorites();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      api.get("/favorites").then(({ data }) => setItems(data)).catch(() => setItems([])).finally(() => setLoading(false));
    } else if (ids.length) {
      Promise.all(ids.map((id) => api.get(`/properties/${id}`).then((r) => r.data).catch(() => null)))
        .then((res) => setItems(res.filter(Boolean)))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [user, ids]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-6">
        <div className="overline text-secondary">Shortlist</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1 flex items-center gap-2">
          <Heart className="text-red-500 fill-red-500" size={30} /> My Favorites
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          {items.length} saved {items.length === 1 ? "property" : "properties"}
        </p>
      </div>

      {loading ? (
        <div className="text-center py-16 text-muted-foreground">Loading...</div>
      ) : items.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-border rounded-xl bg-accent/30" data-testid="favorites-empty">
          <Heart className="text-muted-foreground/40 mx-auto mb-3" size={44} />
          <p className="text-lg font-medium">Abhi koi favorite nahi</p>
          <p className="text-sm text-muted-foreground mt-1">Property card pe ♥ dabakar shortlist banayein.</p>
          <Link to="/browse" className="inline-block mt-4">
            <Button className="bg-primary hover:bg-primary/90 rounded-full">Browse Properties</Button>
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favorites-grid">
          {items.map((p, i) => <PropertyCard key={p.id} property={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
